module.exports = __webpack_public_path__ + "static/media/14.41d02408.jpg";